import { render, staticRenderFns } from "./DatePickerInput.vue?vue&type=template&id=06bf0008"
import script from "./DatePickerInput.vue?vue&type=script&lang=js"
export * from "./DatePickerInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports